import { Icons } from '@components/common';

import { TCategoriesType } from '@interfaces/organisation/organisations';

import { ECommonRequestStatusesForAssetRequest, TCommonRequestStatusesForAssetRequest } from '@enums/asset';
import { EAssetSiteA11yStatus, EBackhaulA11yStatus, EPowerSupplyA11yStatus } from '@enums/map';

import colors from '@constants/colors';

export const generateListOfCategories = (categories: TCategoriesType): string => {
	return categories.map((category) => category.name).join(', ');
};

export const getCheckIcon = (
	enumsType: typeof EBackhaulA11yStatus | typeof EPowerSupplyA11yStatus | typeof EAssetSiteA11yStatus,
	value: string | null,
) => {
	switch (value) {
		case enumsType.red:
			return Icons.uncheck({ color: colors.pink50 });
		case enumsType.amber:
			return Icons.uncheck({ color: colors.yellow50 });
		case enumsType.green:
			return Icons.uncheck({ color: colors.green50 });
		default:
			return '';
	}
};

export const getRequestsStatusesOrder = (enumValue: TCommonRequestStatusesForAssetRequest): number => {
	const enumIndex = Object.values(ECommonRequestStatusesForAssetRequest).indexOf(enumValue);

	return enumIndex !== -1 ? enumIndex : 0;
};
